import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const Container = styled.div``;

// Design-system's html{font-size:50%} breaks PrimeReact's rem-based CSS; .p-button/.p-multiselect-item are already patched app-wide in globals.css, so only the remaining unfixed selectors are here.
export const ScaledContent = styled.div`
    .p-tabview-nav-link {
        font-size: 14px;
        padding: 10px 16px;
    }

    .p-datatable .p-datatable-thead > tr > th,
    .p-datatable .p-datatable-tbody > tr > td {
        font-size: 14px;
        padding: 10px 16px;
    }

    .p-dialog-header {
        font-size: 18px;
        padding: 16px 20px;
    }

    .p-dialog-content {
        font-size: 14px;
        padding: 16px 20px;
    }

    .p-inputtext,
    .p-inputtextarea {
        font-size: 14px;
        padding: 8px 10px;
    }

    .p-dropdown-label,
    .p-multiselect-label {
        font-size: 14px;
        padding: 8px 10px;
    }
`;

export const ReadOnlyValue = styled.div`
    font-size: 14px;
    color: #374151;
`;

export const FieldHint = styled.div`
    font-size: 12px;
    color: #6b7280;
`;

export const PageTitle = styled.h1`
    font-size: ${rem(28)};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    margin: 0 0 ${rem(24)} 0;
    padding: 0;
`;
